import React from 'react';
import { ExternalLinkTracker } from '@/components/analytics/ExternalLinkTracker';

export const ProblemSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-8 items-start">
          
          {/* Colonne gauche - Portrait et infos (25% de la largeur) */}
          <div className="lg:col-span-1 flex flex-col items-center lg:items-start space-y-4">
            <div className="w-24 h-24 rounded-full overflow-hidden border-3 border-gray-300">
              <img 
                src="/assets/Portrait_GE.png" 
                alt="Guillaume - Fondateur DPEWizard"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-center lg:text-left">
              <h3 className="font-bold text-lg text-gray-900 mb-1">Guillaume</h3>
              <p className="text-gray-600 text-sm mb-3">Fondateur DPEWizard</p>
              <ExternalLinkTracker 
                href="https://youtube.com/@NextDeal-FR?sub_confirmation=1"
                trackingLabel="youtube_channel_link"
              >
                <div className="flex items-center justify-center lg:justify-start space-x-2 text-red-500 hover:text-red-400 transition-colors">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  <span className="text-sm font-medium">@NextDealFR</span>
                </div>
              </ExternalLinkTracker>
            </div>
          </div>

          {/* Colonne droite - Contenu textuel (75% de la largeur) */}
          <div className="lg:col-span-3 space-y-6">
            
            {/* Titre avec soulignement style Hormozi */}
            <div>
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
                J'ai gaspillé des centaines de milliers d'euros en travaux inutiles
              </h2>
              <div className="w-12 h-0.5 bg-blue-500 mb-6"></div>
            </div>

            {/* Contenu avec un seul rond au début */}
            <div className="space-y-6">
              
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <img 
                    src="/assets/XXX.png" 
                    alt="Icône chapitre"
                    className="w-6 h-6"
                  />
                </div>
                <div className="space-y-4">
                  <p className="text-base text-gray-700 leading-relaxed">
                    En tant qu'investisseur immobilier professionnel, j'ai dépensé une fortune en rénovations énergétiques. 
                    Mon erreur ? Chercher des classes de lettres inutiles au lieu d'optimiser intelligemment.
                  </p>
                  
                  <p className="text-base text-gray-700 leading-relaxed">
                    Résultat : des centaines de milliers d'euros pour des gains DPE marginaux, pendant que je négligeais 
                    des améliorations simples qui auraient eu un vrai impact.
                  </p>
                  
                  <p className="text-base text-gray-700 leading-relaxed">
                    40% des DPE contiennent des erreurs, mais même avec un DPE correct, on fait souvent les mauvais choix de travaux.
                  </p>
                  
                  <p className="text-lg font-bold text-gray-900 leading-relaxed pt-2">
                    C'est pourquoi j'ai créé DPEWizard : l'outil qui m'aurait fait économiser cette fortune.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;